/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Forgot_Rate_LimitedInputs */

const cs_auth_forgot_rate_limited = /** @type {(inputs: Auth_Forgot_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Příliš mnoho pokusů. Zkuste to znovu za pár minut.`)
};

const en_auth_forgot_rate_limited = /** @type {(inputs: Auth_Forgot_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many attempts. Try again in a few minutes.`)
};

/**
* | output |
* | --- |
* | "Too many attempts. Try again in a few minutes." |
*
* @param {Auth_Forgot_Rate_LimitedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_forgot_rate_limited = /** @type {((inputs?: Auth_Forgot_Rate_LimitedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Forgot_Rate_LimitedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_forgot_rate_limited(inputs)
	return cs_auth_forgot_rate_limited(inputs)
});